<script lang="ts" setup>
import { ThemeType, SiteCode } from "~/shared/enum";

const { cookieThemeType } = useTheme();
const { isSinginModal, setIsSigninModal, setIsSignupModal, setSingleBetPenalty, setIsLoading, themeSetting } =
    useStore();
const { login } = usePrincipal();
const signinFormRef = ref<null | HTMLFormElement>(null);
const signinForm = ref({
    user_id: "",
    password: "",
});
const rules = ref({
    user_id: [
        { required: true, message: "아이디를 입력하세요.", trigger: "blur" },
        { min: 3, max: 15, message: "3-15자 영문 또는 숫자로 입력하세요.", trigger: "blur" },
        { pattern: /^\S*$/, message: "띄어쓰기는 불가능합니다.", trigger: "change" },
        { pattern: /^[A-Za-z0-9]+$/, message: "영문 또는 숫자로 입력하세요.", trigger: "change" },
    ],
    password: [
        { required: true, message: "비밀번호를 입력하세요.", trigger: "blur" },
        { min: 4, max: 20, message: "4-20자 영문 또는 숫자로 입력하세요.", trigger: "blur" },
    ],
});

const submit = () => {
    if (!signinFormRef.value) {
        return;
    }
    signinFormRef.value.validate((valid: boolean) => {
        if (valid) {
            setIsLoading(true);
            useBaseFetch("auth/signin", {
                method: "POST",
                body: signinForm.value,
            })
                .then(async ({ data }) => {
                    if (data) {
                        const { token, ...user } = data.value as any;
                        login({ jwt: token, principal: user });
                        signinFormRef.value.resetFields();

                        // update singleBetPenalty
                        const { data: singleBetPenalty } = await useFetchWithCredentials(
                            "/setting/sports-single-penalty",
                        );
                        setSingleBetPenalty(singleBetPenalty);
                        handleClose();
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            return false;
        }
    });
};

const handleClose = () => {
    setIsSigninModal(false);
};

const handleSignup = () => {
    handleClose();
    setIsSignupModal(true);
};
</script>
<template>
    <div class="acount-form">
        <el-dialog
            :model-value="isSinginModal"
            align-center
            :show-close="false"
            @update:model-value="handleClose"
            :close-on-click-modal="false"
        >
            <button class="form-close-btn" @click="handleClose">
                <i class="las la-times la-2x"></i>
            </button>
            <template #header>
                <NuxtImg src="/images/logo-w.png" alt="logo" width="300" height="52" class="mx-auto" />
            </template>
            <el-form
                id="signinFormModal"
                ref="signinFormRef"
                :model="signinForm"
                :rules="rules"
                @keydown.enter="submit()"
            >
                <el-form-item prop="user_id">
                    <el-input type="text" :placeholder="$t('id')" size="large" v-model="signinForm.user_id" />
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        :placeholder="$t('password')"
                        size="large"
                        v-model="signinForm.password"
                    />
                </el-form-item>
                <div class="flex items-center justify-center">
                    <button class="submit-btn" type="button" @click="submit()">{{ $t("login") }}</button>
                </div>
                <div class="flex items-center justify-center mt-2">
                    <p class="redirect-text" @click="handleSignup">{{ $t("signup") }}</p>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
